import React, { useEffect, useState } from 'react';
import { Button, Modal, message, notification, Table, Card, Input, Popconfirm, Tag,Typography,Row,Col,Breadcrumb } from 'antd';
import { CodeOutlined, DeleteFilled, EditOutlined, FileAddOutlined, SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { setCourse } from '../../slices/courseSlice';
import CourseForm from './Form/CourseForm';
import { useDeleteCourseAdminPMutation, useGetCourseAdminPMutation } from '../../slices/adminApiSlice';
  const { Title, Text } = Typography;

const AdminCoursesScreen = () => {
  const { Title, Text } = Typography;
    const { darkmode } = useSelector((state) => state.darkmode);

  moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
  const [api, contextHolder] = notification.useNotification();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const { course } = useSelector((state) => state.course);
  const dispatch = useDispatch();

  const [getCourses, { isLoading }] = useGetCourseAdminPMutation();
  const [deleteCourse] = useDeleteCourseAdminPMutation();

  const fetchCourses = async () => {
    try {
      const res = await getCourses().unwrap();
      dispatch(setCourse({ ...res }));
      console.log(res);
      
      console.log(course);
    } catch (err) {
      console.error(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleDeleteCourse = async (courseId) => {
    console.log(courseId);
    
    try {
      await deleteCourse({ courseId }).unwrap();
      message.success('Course deleted successfully');
      fetchCourses();
    } catch (err) {
      console.error(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  };

  const handleEditCourse = (course) => {
    setSelectedCourse(course);
    setIsModalVisible(true);
  };

  const showAddCourseModal = () => {
    setSelectedCourse(null);
    setIsModalVisible(true);
  };

  const confirmDelete = (e, courseId) => {
    handleDeleteCourse(courseId);
  };

  // Define columns for the table based on the `courseSchema`
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Title"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, course) => course.title.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Content',
      dataIndex: 'content',
      key: 'content',
      render: (text) => (
        <div style={{ maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {text}
        </div>
      ),
    },
    {
      title: 'PDF',
      dataIndex: 'pdf',
      key: 'pdf',
      render: (pdf) => <a href={pdf} target="_blank" rel="noopener noreferrer">Download PDF</a>,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text, course) => moment(course.createdAt).format('ddd, D MMM, YYYY'),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, course) => (
        <div>
          <Popconfirm
            title="Delete this course?"
            onConfirm={(e) => confirmDelete(e, course.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger shape="circle" size="small" icon={<DeleteFilled />} />
          </Popconfirm>
          <Button
            onClick={() => handleEditCourse(course)}
            shape="circle"
            size="small"
            icon={<EditOutlined />}
            style={{ marginLeft: 8 }}
          />
        </div>
      ),
    },
  ];

  return (
    <>



      <Title
        style={{
          fontFamily: 'Inter, sans-serif',
          marginBottom: '16px', // Added margin below title
        }}
        level={2}
      >
        <CodeOutlined/> &nbsp;All Courses
      </Title>

      <Row
        style={{
          padding: "20px",
          backgroundColor: darkmode ? "#141414" : "#FFF",
          borderRadius: "5px",
          marginBottom: "20px", // Added spacing below breadcrumb row
        }}
      >
        <Col flex="auto">
          <Breadcrumb
            items={[{ title: 'courses' }, { title: 'All Courses' }]}
            style={{ marginBottom: "5px" }}
          />
        </Col>
      </Row>

      {contextHolder}
      <Card title="All Courses" extra={<Button type="primary" onClick={showAddCourseModal} shape="circle"><FileAddOutlined /></Button>}>
        <Table
          columns={columns}
          size="small"
          dataSource={course ? course.course : []}
          loading={isLoading}
          rowKey={(course) => course._id}
          pagination={{ pageSize: 10 }}
          scroll={{ x: 'scroll' }}
        />
      </Card>

      <Modal
        title={selectedCourse ? 'Edit Course' : 'Add Course'}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <CourseForm course={selectedCourse} fetchCourses={fetchCourses} onClose={() => setIsModalVisible(false)} />
      </Modal>
    </>
  );
};

export default AdminCoursesScreen;
